/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExtendableItemS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m9 19 2.917-5.834-4.084-1.75L13.083 5l-1.166 5.25L16 12zm3-17C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgExtendableItemS as ExtendableItemS };
